// @ts-nocheck
"use client";

import { useMemo } from "react";
import Navbar from "./components/navbar/navbar";
import { menuInterpreter } from "./utils/menu-interpreter";

export default function NavbarProvider({
    menuData,
    posts,
    vxiContent,
    CXAHub,
    version,
    baseURL,
    token,
    dismissedWords
}) {
    const menuList = useMemo(
        () => menuInterpreter(menuData, posts),
        [menuData, posts]
    );

    const dismissedProfaneWordsList = dismissedWords
        ?.filter(d => d.attributes.profane)
        ?.map(d => d.attributes.Item) || [];

    return (
        <Navbar
            menuList={menuList}
            menuData={posts}
            menuDataX={menuData}
            posts={posts}
            vxiContent={vxiContent}
            CXAHub={CXAHub}
            version={version}
            baseURL={baseURL}
            token={token}
            mostSearched={[]}
            dismissedWordsList={dismissedProfaneWordsList}
        />
    );
}